import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { YesNoDialogComponent } from '../../components/dialogs/yes-no/yes-no.component';
import { v4 as uuid } from 'uuid';
import { ErrorDialogComponent } from '../../components/dialogs/error/error-dialog.component';
import { SuccessDialogComponent } from '../../components/dialogs/success/success-dialog.component';
import { OptionsDialogComponent } from '../../components/dialogs/options/options-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public openYesNoDialog(vcr: ViewContainerRef) : YesNoDialogComponent {
    let componentRef : ComponentRef<YesNoDialogComponent> = vcr.createComponent(YesNoDialogComponent);
    let id = 'yes-no-dialog-' + uuid();
    componentRef.instance.id = id;
    componentRef.changeDetectorRef.detectChanges();

    this.showModal(id);

    return componentRef.instance;
  }

  public showErrorDialog(vcr: ViewContainerRef, message: string) : void {
    let componentRef : ComponentRef<ErrorDialogComponent> = vcr.createComponent(ErrorDialogComponent);
    let id = 'error-dialog-' + uuid();
    componentRef.instance.id = id;
    componentRef.instance.message = message;
    componentRef.changeDetectorRef.detectChanges();

    this.showModal(id);
  }

  public showSuccessDialog(vcr: ViewContainerRef, message: string) : void {
    let componentRef : ComponentRef<SuccessDialogComponent> = vcr.createComponent(SuccessDialogComponent);
    let id = 'success-dialog-' + uuid();
    componentRef.instance.id = id;
    componentRef.instance.message = message;
    componentRef.changeDetectorRef.detectChanges();

    this.showModal(id);
  }

  public showOptionsDialog(vcr: ViewContainerRef, message: string, options: any[]) : OptionsDialogComponent{
    let componentRef : ComponentRef<OptionsDialogComponent> = vcr.createComponent(OptionsDialogComponent);
    let id = 'options-dialog-' + uuid();
    componentRef.instance.id = id;
    componentRef.instance.message = message;
    componentRef.instance.options = options;
    componentRef.changeDetectorRef.detectChanges();

    this.showModal(id);

    return componentRef.instance;
  }

  private showModal(id: string) : void {
    let trigger = document.createElement('a');
    trigger.href = `#${id}`;
    trigger.setAttribute('data-bs-toggle', 'modal');
    trigger.setAttribute('role', 'button');
    document.body.appendChild(trigger);
    trigger.click();
    trigger.remove();
  }
}
